var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLayoutAssetLg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 60,
  viewBox: "0 0 80 60",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M76 0a4 4 0 0 1 4 4v52a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm0 4H4v52h8v-6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6h24V46a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10h8zM46 31a2 2 0 0 1 2 2v17a2 2 0 0 1-2 2H34a2 2 0 0 1-2-2V33a2 2 0 0 1 2-2zM26 16a2 2 0 0 1 2 2v24a2 2 0 0 1-2 2H14a2 2 0 0 1-2-2V18a2 2 0 0 1 2-2zm40 0a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H54a2 2 0 0 1-2-2V18a2 2 0 0 1 2-2zm-20 0a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H34a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2zm0-8a2 2 0 1 1 0 4H34a2 2 0 1 1 0-4z"
})));
export default SvgLayoutAssetLg;